<template>
    <v-row justify="center">
      <v-dialog
        v-model="show"
        scrollable
        persistent
        max-width="500"
      >
        <v-overlay :value="loaddataprogress" z-index="3" color="black" dark>
          <v-progress-circular indeterminate size="64" color="white">
            <span :style="colorProgress"></span>
          </v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-text class="pa-0">
            <v-list class=" pa-0">
              <v-list-item>
                <!-- <v-list-item-action>

                  <v-icon large :color="filedata.file_icon[1]">
                    {{ filedata.file_icon[0] }}</v-icon
                  >
                </v-list-item-action> -->
                <v-list-item-content>
                  <v-list-item-title style="font-size:large;">{{ $t("setsendemail.sendetaxtoemail") }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon size="35" dense dark :color="color.theme">mdi-email</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text style="max-height: 450px;">
            <v-layout row wrap align-center justify-center style="">
              <v-flex xs11 lg11 ma-5>
                <div v-if="isloadingFetchMail" class="d-flex align-center justify-center">
                  <v-progress-circular  size="32" indeterminate />
                </div>
                <v-card class="elevation-0" v-else>
                  <!-- <v-card-title> -->
                    <!-- <v-icon color="red" class="pb-2">mdi-email</v-icon> -->
                    <!-- {{ $t("setsendemail.sendetaxtoemail") }}</v-card-title> -->
                    <!-- <v-flex lg12 xs12 class="text-center">
                        <v-textarea
                            v-model="setemail"
                            :label="$t('setsendemail.email')"
                            placeholder="johndoe@gmail.com"
                            type="email"
                            outlined
                        ></v-textarea>
                    </v-flex> -->
                  <v-layout row wrap justify-center>
                    <v-flex lg10 xs10 class="text-center">
                      <v-text-field 
                        v-for="(email, index) in emailFields" 
                        :key="index" 
                        v-model="emailFields[index]" 
                        :label="$t('setsendemail.email')"
                        type="email" 
                        required
                        dense
                        outlined
                        :error-messages="getErrorMessages(index)"
                      >
                      <template v-slot:append-outer>
                        <v-icon  @click="removeEmailField(index)" color="red" :disabled="emailFields.length === 1" class="mb-4">mdi-trash-can-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex lg2 xs2 class="text-center">
                  </v-flex> -->
                  </v-layout>
                  <v-layout row wrap justify-center>
                    <v-btn small fab @click="addEmailField" color="primary"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="isloadingFetchMail"
              color="red"
              outlined
              dark
              @click="$emit('closedialog'), (setemail = ''), (emailFields = ['']), (duplicateEmailError = false)"
              >{{ $t("checkpassword.cancel") }}</v-btn
            >
            <v-btn :disabled="isloadingFetchMail || duplicateEmailError" class="white--text" :color="color.theme" @click="fn_sendetaxtoemail()">{{
              $t("checkpassword.ok")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-dialog
        v-model="show"
        persistent
        :max-width="maxWidthOnMobile"
        content-class="rounded-lg"
        v-else
      >
        <v-overlay :value="loaddataprogress" z-index="3" color="black" dark>
          <v-progress-circular indeterminate size="64" color="white">
            <span :style="colorProgress"></span>
          </v-progress-circular>
        </v-overlay>
        <v-card>
          <v-card-text class="pa-5">
            <v-layout class="pt-2 pb-4">
              <v-flex d-flex justify-center class="ml-8">
                <span :style="headerPage">{{
                  $t("checkpassword.setpassword")
                }}</span>
              </v-flex>
              <v-flex xs1 d-flex justify-end>
                <v-icon
                  :color="color.theme"
                  @click="$emit('close'), (password = '')"
                  >mdi-close</v-icon
                >
              </v-flex>
            </v-layout>
            <span :style="title">{{ $t("checkpassword.setpassword") }}</span>
            <v-text-field
              class="mt-1 textFieldClass"
              :color="color.theme"
              outlined
              dense
              v-model="password"
              :type="showpassword ? 'text' : 'password'"
              :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
              height="35px"
              @click:append="showpassword = !showpassword"
              autocomplete="new-password"
              persistent-hint
            ></v-text-field>
            <div class="text-center">
              <v-btn
                :style="btnAction"
                class="mr-6"
                height="40px"
                width="45%"
                color="red"
                outlined
                @click="$emit('close'), (password = '')"
                >{{ $t("checkpassword.cancel") }}</v-btn
              >
              <v-btn
                class="elevation-0"
                :style="btnAction"
                height="40px"
                width="45%"
                :color="color.theme"
                :dark="color.darkTheme"
                @click="createpassword(), (password = '')"
                >{{ $t("checkpassword.ok") }}</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </v-dialog> -->
    </v-row>
  </template>
  
  <script>
  import { mapState, mapGetters } from "vuex";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import gbfGenerate from "@/globalFunctions/generateAuthorize";
   import { validationMixin } from "vuelidate";
  import { email } from "vuelidate/lib/validators";
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });
  
  export default {
    mixins: [validationMixin],
    validations: {
      emailFields: {
      $each: {
        email: (value) => {
          if (!value) return false;
          // ใช้ regex ที่รองรับ case-insensitive และตรวจสอบรูปแบบ email เท่านั้น
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
          return emailRegex.test(value);
        },
      },
    },
    },
    data() {
      return {
      inboxid:[],
      duplicateEmailError: false,
      isloadingFetchMail: false,
      listdata:[],
      emailFields: [""],  // Array สำหรับเก็บช่องกรอกอีเมล
      emailRules: [
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(v) || 'โปรดกรอกอีเมลที่ถูกต้อง'  // Rule การตรวจสอบอีเมล (รองรับ case-insensitive)
      ],
        loaddataprogress: false,
        password: "",
        showpassword: false,
        opensuccess: false,
      };
    },
    props: ["show", "data"],
    computed: {
      ...mapState([
        "username",
        "authorize",
        "account_active",
        "color",
        "role_level",
      ]),
      ...mapState({ processloader: "loading" }),
      ...mapGetters([
        "dataUsername",
        "dataAuthorize",
        "dataAccountActive",
        "dataAccesstoken",
        "dataBusinessProfile",
        "dataCitizenProfile",
        "dataDepartmentAccessId",
        "dataAccountId",
      ]),
      resolutionScreen() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return 220;
          case "sm":
            return 400;
          case "md":
            return 500;
          case "lg":
            return 600;
          case "xl":
            return 800;
        }
      },
      headerPage() {
        return (
          "color:" +
          this.color.theme +
          ";" +
          "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
        );
      },
      title() {
        return "color:black; font-size: 14px; line-height: 28px;";
      },
      btnAction() {
        return "font-size: 16px; font-weight: lighter;";
      },
      textfield() {
        return "min-height: 1px;";
      },
      success() {
        return "color:#58A144; font-size: 18px; line-height: 24px;";
      },
      // ความกว้างของ dialog ของ ipad และ mobile
      maxWidthOnMobile() {
        if (this.resolutionScreen >= 400) {
          return 600;
        } else {
          return 346;
        }
      },
    },
    watch: {
      show: function (newVal) {
        if (newVal) {
          this.fetchHeader ()

        }
      },
      emailFields: function (newVal) {
        const emailList = newVal.map(item => {
        if (typeof item === 'string') {
          return item.trim().toLowerCase();
        } else if (item && typeof item === 'object' && item.email) {
          return item.email.trim().toLowerCase();
        }
        return null;
        }).filter(Boolean);

        const duplicates = emailList.filter((email, index, arr) => arr.indexOf(email) !== index);
        console.log('duplicate values', duplicates);

        this.duplicateEmailError = duplicates.length > 0;
        
      },
    },
    methods: {
    getErrorMessages(index) {
      const field = this.$v.emailFields.$each[index];
      if (!field || !field.$error) return [];

      const messages = [];
      if (!field.required) messages.push(this.$t('default') === 'th' ? "กรุณากรอกอีเมล" : "Email is required");
      if (!field.email) messages.push(this.$t('default') === 'th' ? "รูปแบบอีเมลไม่ถูกต้อง" : "Invalid email format");
      return messages;
    },
    async fetchHeader () { 

      this.inboxid = [];
       if(this.data.length >= 1){
        for(let i=0; i < this.data.length; i++){
          this.inboxid.push(this.data[i].inbox_id)
          console.log("this.data[i].inbox_id",this.data[i].inbox_id);         
        }
      }else{
         this.inboxid.push(this.data.inbox_id)
      }
      
      let auth = await gbfGenerate.generateToken();
      this.isloadingFetchMail = true
      let payload = {
        user_id: this.dataUsername,
        account_id: this.dataAccountId,
        // inbox_id: this.data.inbox_id,
        inbox_id: this.inboxid,
        business_id: this.dataAccountActive.business_info.business_id,
      }
      console.log("dataaa indebox ", payload, this.dataAccountActive)
      await this.axios
        .post(
          process.env.VUE_APP_SERVICE_UPLOAD_API + "/api/get_email_default_etax_attachment",
          payload,
          { headers: { Authorization: auth.code } }
        )
        .then((response) => {
          console.log(typeof(response.data.receiver_email));
          this.isloadingFetchMail = false
          if (response.data.status === "OK") {
            this.emailFields = !['', null, undefined].includes(response.data.receiver_email) ? typeof(response.data.receiver_email) === 'string' ? [response.data.receiver_email] : [...response.data.receiver_email] : ['']
          }else{
            
          }
          
        });
    },
     // ฟังก์ชันเพิ่มช่องกรอกอีเมล
    addEmailField() {
      this.emailFields.push('');  // เพิ่มช่องกรอกอีเมลใหม่
    },

    // ฟังก์ชันลบช่องกรอกอีเมล
    removeEmailField(index) {
      this.emailFields.splice(index, 1)
      // this.emailFields.pop();  // ลบช่องกรอกอีเมลล่าสุด
    },
      colorProgress() {
        return "color:" + "white" + ";";
      },
      async fn_sendetaxtoemail(){
        // check duplicate mail

        if (this.emailFields.length === 0 || this.emailFields.every(item => item === "")) {
          return;
        } else {
          this.emailFields = this.emailFields.filter((item) =>  item !== "")
        }
        
        this.loaddataprogress = true;
        // console.log("emailFields",this.emailFields);
        // console.log("this.data",this.data);
        // console.log("this.data.length",this.data.length);
        
        this.listdata = [];
        if(this.data.length >= 1){
          for(let i=0; i < this.data.length; i++){
            this.listdata.push(this.data[i].inbox_id)
            console.log("this.data[i].inbox_id",this.data[i].inbox_id);         
          }
        }else{
          this.listdata.push(this.data.inbox_id)
        }
        // console.log("this.listdata",this.listdata);
        
        let payload = {
        account_id: this.dataAccountId,
        user_id: this.dataUsername,
        receiver_email: this.emailFields,
        inbox_id: this.listdata,
        folder_id: "",
      };
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loaddataprogress = false
        return
      }
      let auth = await gbfGenerate.generateToken();
      console.log("auth",auth);
      
      // console.log("payload",payload);
      await this.axios
        .post(
          process.env.VUE_APP_SERVICE_UPLOAD_API + "/api/send_etax_attachment",
          payload,
          { headers: {
                Authorization: auth.code
              }, }
        )
        .then((response) => {
          // console.log(response);
          if (response.data.status === "OK") {
            Toast.fire({
              icon: "success",
              title: this.$t('default') === 'en' ? "Send to email success" : "ส่งอีเมลสำเร็จ",
            });
            this.loaddataprogress = false;
          }else{
            Toast.fire({
              icon: "error",
              title:response.data.errorMessage,
            });
            this.loaddataprogress = false;
          }
          this.emailFields = [""]
          this.$emit("closedialog");
        });
      }
    },
  };
  </script>
  <style>
  .v-text-field.textFieldClass .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }
  .v-input.textFieldClass input {
    font-size: 14px;
  }
  </style>
  